import { render } from "./cookie-banner.vue?vue&type=template&id=df56b484&scoped=true"
import script from "./cookie-banner.vue?vue&type=script&lang=js"
export * from "./cookie-banner.vue?vue&type=script&lang=js"

import "./cookie-banner.vue?vue&type=style&index=0&id=df56b484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df56b484"]])

export default __exports__